<div class="heading heading_standard heading_centered">Reset password</div>
<div class="form__desc">
  I rememeber login details.
  <a routerLink="/auth/sign-in"><strong>Login</strong></a>
</div>

<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  [appScrollToInvalidFieldOnFormSubmit]
  [scrollElement]="ScrollElements.WINDOW"
>
  <div class="fields">
    @if (tokenFC.invalid) {
      <p class="system-error">
        {{ tokenFC.errors?.[0] }}
      </p>
    }

    <app-new-password />

    <button
      type="submit"
      class="button button_dark button_standard button_centered"
    >
      Set new password
    </button>

    <p>
      Please enter a new password for your account. Once you set your new
      password, you can use it to log in to our website.
    </p>
  </div>
</form>
